export default "__VITE_ASSET__Bj0AmEz6__"